export function useConsentLink() {
  let observer = null;

  const bindConsentLink = async () => {
    const links = document.querySelectorAll(".termly-display-preferences");

    links.forEach((link) => {
      if (link.dataset.consentBound) return;
    
      const cleanLink = link.cloneNode(true);
      cleanLink.dataset.consentBound = 'true';
      cleanLink.href = '#';
      
      link.replaceWith(cleanLink);
      cleanLink.addEventListener("click", e => {
        e.preventDefault();
        if (window.Termly?.displayConsentManager) {
          window.Termly.displayConsentManager();
        } else {
          console.error('Termly consent manager not available');
        }
      });
    });

    return links.length > 0;
  };

  const startObserver = () => {
    stopObserver();
    
    observer = new MutationObserver((mutations) => {
      let shouldBind = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const hasConsentLink = node.classList?.contains('termly-display-preferences') || 
                                   node.querySelector?.('.termly-display-preferences');
              
              if (hasConsentLink) {
                shouldBind = true;
              }
            }
          });
        }
      });
      
      if (shouldBind) {
        setTimeout(() => bindConsentLink(), 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  const stopObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const bindConsentLinkWithRetry = async (maxAttempts = 10, interval = 200) => {
    let attempts = 0;
    
    startObserver();
    
    const tryBind = async () => {
      await bindConsentLink();
      
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(tryBind, interval);
      }
    };
    
    await tryBind();
  };

  return {
    bindConsentLink,
    bindConsentLinkWithRetry,
    startObserver,
    stopObserver
  };
}
